import L from "leaflet"
import DialogController from "./dialog-controller"
import angular from "angular"

let isMarkerClick = false

let mapBounds
let allMarkerLayers
let allMarkerLayersLength = 0

const largeFacilityIcon = L.divIcon({
  className: "my-div-icon leaflet-zoom-hide facility",
  iconSize: [80, 80],
  html: '<div class="marker-icon"><i class="fa fa-map-marker"></div>',
})

const largeHighlightedIcon = L.divIcon({
  className: "my-div-icon leaflet-zoom-hide facility icon-highlighted",
  iconSize: [80, 80],
  html: '<div class="highlight-circle"</div><div class="marker-icon"><i class="fa fa-map-marker"></div>',
})

const largeSurroundingsIcon = L.divIcon({
  className: "my-div-icon leaflet-zoom-hide surroundings",
  iconSize: [80, 80],
  html: '<div class="marker-icon"><i class="fa fa-map-marker"></div>',
})

const largeSurroundingsHighlightedIcon = L.divIcon({
  className: "my-div-icon leaflet-zoom-hide surroundings icon-highlighted",
  iconSize: [80, 80],
  html: '<div class="highlight-circle"</div><div class="marker-icon"><i class="fa fa-map-marker"></div>',
})

const MOBILE_MARKER_DETAIL_CLOSED_PANEL_HEIGHT = 103
const MOBILE_TOP_BAR_HEIGHT = 32

export class MapController {
  // viewRemoved;
  /*@ngInject*/

  constructor(
    $http,
    $scope,
    $window,
    $state,
    $filter,
    $transitions,
    $q,
    $stateParams,
    Auth,
    $mdDialog,
    $sce,
    $timeout
  ) {
    this.$scope = $scope
    this.$window = $window
    this.$state = $state
    this.$filter = $filter
    this.$transitions = $transitions
    this.selectedMarker = undefined
    this.$http = $http
    this.$q = $q
    this.$stateParams = $stateParams
    this.$mdDialog = $mdDialog
    this.physicalUnitCallPromises = []
    this.pitchNameData = []
    this.$sce = $sce
    this.$timeout = $timeout

    this.Auth = Auth

    this.layerGroups = {}
    this.detailShowing = false
    this.isManaging = false
    this.dragged = false
  }

  resetMapSize(needsApply = true) {
    if (this.map) {
      if (needsApply && !this.$scope.$$phase) {
        this.$scope.$apply() //needed to be add so that map size loads correctly strange
      }

      this.$timeout(() => {
        this.map.invalidateSize()
      }, 0)
    }
  }

  dummyMarkerIcon = (textString) =>
    L.divIcon({
      className: "my-div-icon leaflet-zoom-hide dummy-marker",
      iconSize: [80, 80],
      html: `<div class="highlight-circle"</div><div class="marker-icon">${textString}</div>`,
    })

  getDummyIcon(textString) {
    return this.dummyMarkerIcon(textString)
  }

  // currently changing map height per view is not working
  getMapHeight() {
    // if (this.$state.current.name === "mainmap.home.availability-status") {
    //   const flexDatesFeatureHeight = this.campsitedata.showFlexibleDates ? 32 : 0;
    //   return MOBILE_MARKER_DETAIL_CLOSED_PANEL_HEIGHT + MOBILE_TOP_BAR_HEIGHT + flexDatesFeatureHeight
    // }

    //if (this.$state.current.name === "mainmap.home" || this.$state.current.name === "mainmap") {
    return MOBILE_MARKER_DETAIL_CLOSED_PANEL_HEIGHT + MOBILE_TOP_BAR_HEIGHT
    // }
  }

  setMainMapSize() {
    this.sizeMapStyle = {}

    if (this.isManagePage || (!this.isManagePage && !this.isMobile)) {
      const sidePanelWidth =
        this.$state.current.name === "mainmap.manage" || this.$state.current.name === "surroundings.manage" ? 500 : 300
      this.sizeMapStyle.width = `${this.$window.innerWidth - sidePanelWidth}px`
      this.touchEnabled = false
    } else {
      this.touchEnabled = true
      // need to check this and change it for flexible viewing?
      // const heightOffset =
      //   this.$state.current.name === "surroundings.markers.detail" ||
      //     this.$state.current.name === "mainmap.markers.detail"
      //     ? MOBILE_MARKER_DETAIL_CLOSED_PANEL_HEIGHT + MOBILE_TOP_BAR_HEIGHT
      //     : this.$state.current.name === "mainmap.home" ||
      //       this.$state.current.name === "mainmap" ||
      //       this.$state.current.name === "mainmap.home.availability-status"
      //       ? 121
      //       : 147
      const heightOffset = this.getMapHeight()
      // should also be minus top bar height (32px)?
      // console.log(this.$window.innerHeight)
      // console.log(heightOffset)
      this.sizeMapStyle.height = `${this.$window.innerHeight - heightOffset}px`
    }

    this.mapAerialStyle = { ...this.backgroundColourStyle, ...this.sizeMapStyle }
    this.resetMapSize()
  }

  getDivIcon(type, textString, ishighlighted, isFacilityIconBlank) {
    if (type === "pitch" && !ishighlighted) {
      return this.getLargeBlankIcon()
    }

    if (type === "facility" && !ishighlighted && isFacilityIconBlank) {
      return this.getLargeBlankIcon()
    }

    if (type === "facility" && !ishighlighted) {
      return largeFacilityIcon
    }

    if (type == "facility" && ishighlighted) {
      return largeHighlightedIcon
    }

    if (type === "surroundings" && !ishighlighted) {
      return largeSurroundingsIcon
    }

    if (type == "surroundings" && ishighlighted) {
      return largeSurroundingsHighlightedIcon
    }

    if (type === "dummymarker") {
      return this.getDummyIcon(textString)
    }

    return largeHighlightedIcon

    // todo perhaps there should be an object with each divicon stored ready with pitch num as key instead of having to build it every time its highlighting
    // return L.divIcon({
    //   className: "my-div-icon leaflet-zoom-hide icon-highlighted",
    //   iconSize: [50, 50],
    //   html: `<div class="highlight-circle"></div><div class="text">${textString}</div>`,
    // });
  }

  getMarkerOpts(type, markerdata) {
    // TODO shouldn't really be returning all unserialized data here, may not be needed! need to set explicitly. Should be immutable, not patching source data
    return markerdata
  }

  openPopup(e, marker) {
    const markerData = marker.options
    let popupHtml = `
    <div>
      <div class="highlight-content">
        <div class="text-area">
          <div class="title-name">
            <span>${markerData.plottype ? markerData.plottype : markerData.type === "pitch" ? "Pitch" : ""} </span>${
              markerData.name
            }
          </div>
        </div>
      </div>
    </div>`

    let popupOptions = {
      autoPan: false,
      offset: new L.Point(0, -20),
      className: "pitch-popup leaflet-zoom-hide",
      autoPanPadding: [50, 50],
    }

    return new L.Popup(popupOptions).setLatLng([e.latlng.lat, e.latlng.lng]).setContent(popupHtml).openOn(this.map)
  }

  createMarker(markerdata = {}, type = "pitch") {
    const newMarker = { ...markerdata }

    //  perhaps icon needs to source from a predefined object of icons
    let icontypestring
    let urlId

    //newMarker.urlstringid = newMarker.urlstringid.toLowerCase() || "default";

    newMarker.icontypestring = icontypestring
    newMarker.id = urlId
    newMarker.type = type

    if (!newMarker.imageVersions) {
      newMarker.imageVersions = []
    }

    if (type === "pitch") {
      urlId = newMarker.name || "default"
      icontypestring = newMarker.name || "default"
      let pitchTypeData
      let pitchTypeSubTypeData
      if (this.campsitedata.pitchNumbersOnPitchTypes) {
        const allPitchTypeData = this.getPitchTypeDataFromPitchId(markerdata._id)
        pitchTypeData = allPitchTypeData.pitchTypeData
        pitchTypeSubTypeData = allPitchTypeData.pitchTypeSubTypeData
      } else {
        pitchTypeData = this.getPitchTypeData(markerdata.pitchtype)
        if (pitchTypeData) {
          if (pitchTypeData.subTypes && markerdata.pitchTypeSubType) {
            pitchTypeSubTypeData = this.getPitchTypeSubTypeData(pitchTypeData, markerdata.pitchTypeSubType)
          }
        }
      }

      newMarker.plottype = "pitch"
      if (pitchTypeData) {
        newMarker.pitchTypeData = pitchTypeData
        if (this.campsitedata.pitchNumbersOnPitchTypes || !newMarker.pitchtype) {
          newMarker.pitchtype = pitchTypeData.type
        }
        newMarker.plottype = pitchTypeData?.plottype || "pitch"
      }
      if (pitchTypeSubTypeData) {
        newMarker.pitchTypeSubTypeData = pitchTypeSubTypeData
        if (!newMarker.pitchTypeSubType) {
          newMarker.pitchTypeSubType = pitchTypeSubTypeData.type
        }
      }

      if (this.campsitedata.showavailability && !this.isSurroundingOnlyMode && newMarker.physicalunitid) {
        newMarker.physicalUnitId = newMarker.physicalunitid
      }
    } else {
      urlId = newMarker.urlstringid
      icontypestring = newMarker.urltypestringid
    }

    //if is manage mode show permanent marker position
    if (!this.isManagePage) {
      if (type === "facility") {
        newMarker.icon = this.getDivIcon(type, icontypestring, false, newMarker.isFacilityIconBlank)
      } else {
        newMarker.icon = this.getDivIcon(type, icontypestring, false)
      }
    } else {
      newMarker.icon = this.getDivIcon("dummymarker", urlId, false)
    }

    let latLng = [newMarker.lat, newMarker.lng]
    let marker = L.marker(latLng, newMarker)

    this.addMapItemListeners(marker)

    return marker
  }

  deselectSelectedMarkerAndSetIcon(icon) {
    this.selectedMarker.setZIndexOffset(1000)
    this.selectedMarker.setIcon(icon)
    // Store this icon as the previous icon for future selections
    this.selectedMarker.options.previousIcon = icon
    this.selectedMarker = undefined
  }

  deHighlightSelectedMarker() {
    let isDeselected = false
    if (
      this.selectedMarker.options.type === "pitch" &&
      this.campsitedata.showavailability &&
      !this.$window.flippers.isAvailabilityHidden
    ) {
      isDeselected = this.deselectAvailabiltyPitch()
    }
    if (!isDeselected && this.selectedMarker?.setIcon) {
      this.selectedMarker.setZIndexOffset(1000)

      // Use the previously stored icon if available, otherwise generate a default icon
      let icon
      if (this.selectedMarker.options.previousIcon) {
        icon = this.selectedMarker.options.previousIcon
      } else {
        const { type, icontypestring } = this.selectedMarker.options
        icon = this.getDivIcon(type, icontypestring, false, this.selectedMarker.options.isFacilityIconBlank)
      }

      this.selectedMarker.setIcon(icon)
      this.selectedMarker = undefined
    }
  }

  getPitchImageTrailingCharacters(index) {
    if (this.campsitedata.pitchPhotoExtensionFrontBack) {
      if (index === 0) {
        return "f"
      }
      return "b"
    }

    if (index === 0) {
      return ""
    }

    if (this.campsitedata.useNewPitchImageNaming) {
      return `-${index.toString()}`
    }

    return index.toString()
  }

  getBaseString(typeString) {
    return `https://dwf18h5sawogn.cloudfront.net/ppphotos/${this.campsitedata.name}/${typeString}/`
  }

  simplifyUrlString(string) {
    return string.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
  }

  getPitchTypeData(pitchtype) {
    return this.campsitedata.pitchtypes.find((pitchtypeoption) => pitchtypeoption.type === pitchtype)
  }

  getPitchTypeSubTypeData(pitchTypeData, pitchTypeSubType) {
    return pitchTypeData.subTypes.find((subType) => subType.name === pitchTypeSubType)
  }

  shouldUseSubTypeImage(pitchType, pitchTypeSubType) {
    const pitchTypeData = this.getPitchTypeData(pitchType)

    const pitchTypeSubTypeData =
      pitchTypeData && pitchTypeData.subTypes ? this.getPitchTypeSubTypeData(pitchTypeData, pitchTypeSubType) : null

    return pitchTypeSubType && pitchTypeSubTypeData && pitchTypeSubTypeData.overridePitchTypeImage
  }

  getImageVersionString(str) {
    if (str) {
      return str
    }
    return ""
  }

  getPitchImageUrls(type, overridePitchImage, urlstringid, numOfImages, pitchType, pitchTypeSubType, imageVersions) {
    let pitchImageUrls = []
    let typeString = type === "facility" ? "facilities" : "surroundings"

    if (type === "pitch") {
      if (
        !this.campsitedata.isPitchImageBasedOnType ||
        (this.campsitedata.isPitchImageBasedOnType && overridePitchImage)
      ) {
        const numofpitchimagesperpitch = this.campsitedata.numofpitchimagesperpitch
          ? this.campsitedata.numofpitchimagesperpitch
          : 2
        for (let i = 0; i < numofpitchimagesperpitch; i++) {
          pitchImageUrls.push(
            `${this.getBaseString("pitches")}${urlstringid}${this.getPitchImageTrailingCharacters(
              i,
              this.campsitedata.useNewPitchImageNaming
            )}${this.getImageVersionString(imageVersions[i])}.jpg`
          )
        }
      } else if (this.campsitedata.isPitchImageBasedOnType) {
        const shouldUseSubTypeImage = this.shouldUseSubTypeImage(pitchType, pitchTypeSubType)
        pitchImageUrls.push(
          `${this.getBaseString("pitches")}${this.simplifyUrlString(
            shouldUseSubTypeImage ? pitchTypeSubType : pitchType ? pitchType : ""
          )}${this.getImageVersionString(imageVersions[0])}.jpg`
        )
      }
    } else if (type !== "area") {
      const numOfPhotos = parseInt(numOfImages) || 1

      for (let i = 0; i < numOfPhotos; i++) {
        pitchImageUrls.push(
          `${this.getBaseString(typeString)}${urlstringid}${i === 0 ? "" : i}${this.getImageVersionString(
            imageVersions[i]
          )}.jpg`
        )
      }
    }
    return pitchImageUrls
  }

  showFullscreenGallery() {
    const selectedMarkerType = this.transitionParams.markers
    this.pitchImageUrls = this.getPitchImageUrls(
      selectedMarkerType,
      this.selectedMarker.options.overridePitchImage,
      this.selectedMarker.options.urlstringid,
      this.selectedMarker.options.numOfPhotos,
      this.selectedMarker.options.pitchtype,
      this.selectedMarker.options.pitchTypeSubType,
      this.selectedMarker.options.imageVersions
    )

    this.galleryShowing = true
  }

  removeGallery = () => {
    this.galleryShowing = false
    this.$scope.$apply()
  }

  activateMarker(marker) {
    if (this.selectedMarker) {
      this.deHighlightSelectedMarker()
    }
    this.setCorrectHighlight(marker)
  }

  setCorrectHighlight(marker) {
    if (this.$state.current.name.includes("mainmap")) {
      this.setMarkerAsAvailable(marker)
    }

    // Store the current icon before changing it
    marker.options.previousIcon = marker.options.icon

    this.selectedMarker = marker

    //  perhaps needs to source from a predefined object of icons
    marker.setZIndexOffset(4000)
    let icon
    const { type, icontypestring } = marker.options
    if (this.selectedMarker.options.type === "facility") {
      icon = this.getDivIcon(type, icontypestring, true, this.selectedMarker.options.isFacilityIconBlank)
    } else {
      icon = this.getDivIcon(type, icontypestring, true)
    }
    this.selectedMarker.setIcon(icon)
    marker.setIcon(icon)
  }

  getMarkerData(type, urlstringid) {
    let dataArray

    if (type === "pitch") {
      dataArray = this.campsitedata.markers
    }

    if (type === "facility") {
      dataArray = this.campsitedata.facilities
    }

    if (type === "surroundings") {
      dataArray = this.campsitedata.placesofinterest
    }

    if (type === "area") {
      dataArray = this.campsitedata.areaoptions
    }

    return dataArray.find((item) => item.urlstringid === urlstringid)
  }

  updateMap = (field, data) => {
    let params = {}
    params[field] = data
    return this.$http.put(`/api/campsites/${this.campsitedata._id}`, params).then(
      () => {
        this.campsitedata[field] = data
        if (field === "facilities" || field === "areaoptions" || field === "placesofinterest") {
          this.refreshMarkers()
          this.$mdDialog.hide()
        }
      },
      (failureCallback) => {
        console.error(failureCallback)
      }
    )
  }

  refreshMarkers() {
    this.layerGroups.allMarkers.eachLayer((layer) => {
      this.map.removeLayer(layer)
    })
    this.addMarkers()
    this.setAllMarkersLengthForOptim()
    this.showAllAllVisibleMarkers("allMarkers")
  }

  getMarkerIndex(urlstringid, type) {
    return this.campsitedata[type].findIndex((markerLayer) => markerLayer.urlstringid === urlstringid)
  }

  deleteMarker = (type, urlstringid) => {
    if (type === "pitch") {
      const marker = this.getMarkerData(type, urlstringid)
      const markerId = marker._id
      this.$http.delete(`/api/markers/${markerId}`).then(
        (response) => {
          console.log(response)
          const pitchMarkerIndex = this.getMarkerIndex(urlstringid, "markers")
          this.campsitedata.markers.splice(pitchMarkerIndex, 1)
          this.refreshMarkers()
          this.$mdDialog.hide()
        },
        (reason) => {
          // rejection
          console.error(reason)
        }
      )
    }

    if (type === "facility") {
      const facilityIndex = this.getMarkerIndex(urlstringid, "facilities")
      this.campsitedata.facilities.splice(facilityIndex, 1)
      this.updateMap("facilities", this.campsitedata.facilities)
    }

    if (type === "area") {
      const areaIndex = this.getMarkerIndex(urlstringid, "areaoptions")
      this.campsitedata.areaoptions.splice(areaIndex, 1)
      this.updateMap("areaoptions", this.campsitedata.areaoptions)
    }
  }

  // this should be called on drag end
  saveUpdatedMarkerPosition(lat, lng, id) {
    const pitchDataToSave = {
      lat,
      lng,
      _id: id,
    }

    this.updatePitchMarkers(pitchDataToSave, true)
  }

  addUrlStringIdToString = (markerData) => {
    if (this.campsitedata.pitchnumberbyarea && markerData.area) {
      markerData.urlstringid = `${markerData.name}-${markerData.area.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()}`
      markerData.nameandareastring = `${markerData.name} - ${markerData.area}`
    } else {
      markerData.urlstringid = markerData.name.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
    }
    return markerData
  }

  updatePitchMarkers = (newPitchToSave, isEditing) => {
    let httpFn
    let url
    if (isEditing) {
      httpFn = this.$http.put
      url = `/api/markers/${newPitchToSave._id}`
      Reflect.deleteProperty(newPitchToSave, "_id")
      Reflect.deleteProperty(newPitchToSave, "__v")
    } else {
      httpFn = this.$http.post
      url = "/api/markers"
    }
    httpFn(url, newPitchToSave).then(
      (response) => {
        const markerData = response.data
        this.addUrlStringIdToString(markerData)

        if (isEditing) {
          const existingMarkerDataIndex = this.campsitedata.markers.findIndex(
            (item) => item.urlstringid === markerData.urlstringid
          )
          this.campsitedata.markers[existingMarkerDataIndex] = markerData
        } else {
          this.campsitedata.markers.push(markerData)
          const newMapMarker = this.createMarker(markerData, "pitch")
          this.addPolygonToMarker(markerData, newMapMarker)
          this.layerGroups.allMarkers.addLayer(newMapMarker)
          this.setAllMarkersLengthForOptim()
          this.showAllAllVisibleMarkers("allMarkers")
        }
        this.$mdDialog.hide()
      },
      (reason) => {
        // rejection
        console.log(reason)
      }
    )
  }

  changePosition = (markerData) => {
    console.log("changing position")
    this.$mdDialog.hide()
    this.manageFeedback = "Drag the marker to new position"
    this.addMarkerButtonReady = false
    const markerLayer = this.findMarkerByName(markerData.urlstringid)
    markerLayer.dragging.enable()
    markerLayer.on("drag", () => {
      markerLayer.on("dragend", (dragendEvt) => {
        markerLayer.off("drag")
        markerLayer.off("dragend")
        this.dragged = true // because for some reason click event firing
        this.manageFeedback = ""
        this.addMarkerButtonReady = true

        // this causing a click event or something for some reason?
        dragendEvt.target.dragging.disable()
        const type = dragendEvt.target.options.type
        const newlatLng = dragendEvt.target.getLatLng()

        if (type === "pitch") {
          this.saveUpdatedMarkerPosition(newlatLng.lat, newlatLng.lng, markerData._id)
        } else {
          let itemArrayName
          if (markerData.type === "facility") {
            itemArrayName = "facilities"
          }

          if (markerData.type === "area") {
            itemArrayName = "areaoptions"
          }

          if (markerData.type === "placeofinterest") {
            itemArrayName = "placesofinterest"
          }

          const itemArray = [...this.campsitedata[itemArrayName]]
          const newItem = { ...markerData }
          if (itemArrayName === "areaoptions") {
            newItem.centerlat = newlatLng.lat
            newItem.centerlng = newlatLng.lng
          } else {
            newItem.lat = newlatLng.lat
            newItem.lng = newlatLng.lng
          }
          newItem.lat = newlatLng.lat
          newItem.lng = newlatLng.lng
          const itemIndex = this.getMarkerIndex(newItem.urlstringid, itemArrayName)
          itemArray[itemIndex] = newItem
          this.updateMap(itemArrayName, itemArray)
        }
      })
    })
  }

  showNewMarkerForm(evt, isEditing) {
    const data = {
      campsiteInfo: this.campsitedata,
      markerLatLng: evt.latlng,
      availabilityPitchNameData: this.availabilityPitchNameData,
    }

    //TODO this should probably be the source data not the marker options data as different for different markers
    let pitchImageUrls = null
    const markerOptions = evt.target.options
    if (isEditing) {
      data.markerData = this.getMarkerData(markerOptions.type, markerOptions.urlstringid)
      data.markerData.type = markerOptions.type

      // perhaps shhould be set in the data load
      if (!data.markerData.imageVersions) {
        data.markerData.imageVersions = []
      }

      pitchImageUrls = this.getPitchImageUrls(
        markerOptions.type,
        markerOptions.overridePitchImage,
        markerOptions.urlstringid,
        markerOptions.numOfPhotos,
        markerOptions.pitchtype,
        markerOptions.pitchTypeSubType,
        markerOptions.imageVersions
      )
    }

    this.$mdDialog.show({
      locals: {
        isEditing,
        data,
        changePosition: this.changePosition,

        pitchImageUrls,
        updatePitchMarkers: this.updatePitchMarkers,
        deleteMarker: this.deleteMarker,
        updateMap: this.updateMap,
        isAdmin: this.isAdmin,
        editMarkerInteractionShape: this.editMarkerInteractionShape,
        addUrlStringIdToString: this.addUrlStringIdToString,
        campsitedata: this.campsitedata,
        addPolygonToMarker: this.addPolygonToMarker,
        layerGroups: this.layerGroups,
        setAllMarkersLengthForOptim: this.setAllMarkersLengthForOptim,
        showAllAllVisibleMarkers: this.showAllAllVisibleMarkers,
        getMarkerData: this.getMarkerData,
        refreshMarkers: this.refreshMarkers,
      },
      controller: DialogController,
      template: require("./markerdialog.tmpl.html"),
      parent: angular.element(document.getElementById("dialog1")),
      //targetEvent: ev,
      controllerAs: "ctrl",
      clickOutsideToClose: true,
      //fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
    })
  }

  addEventListeners() {
    this.mapWindowResize = this.$scope.$on("watchWindowResize::resize", () => {
      this.setMainMapSize()
    })
  }

  returnStringAsNumber(marker) {
    return Number(marker.name)
  }

  addAllMarkerTypes(typesData) {
    this.layerGroups.allMarkers = new L.layerGroup()
    for (let i = 0; i < typesData.length; i++) {
      this.addMarkerLayers(typesData[i].type, typesData[i].data)
    }
  }

  addLayerToAllMarkers(layer) {
    if (layer && layer !== null) {
      this.layerGroups.allMarkers.addLayer(layer)
    }
  }

  addMapItemListeners(marker, polygonOriginalMarker) {
    if (!this.isManagePage) {
      marker.on("click", () => {
        isMarkerClick = true
        const markerForHighlight = polygonOriginalMarker ? polygonOriginalMarker : marker
        this.activateMarker(markerForHighlight)
        let result = { markers: markerForHighlight.options.type, name: markerForHighlight.options.urlstringid }
        if (this.$state.includes("mainmap")) {
          this.$state.go("mainmap.markers.detail", result)
        } else {
          this.$state.go("surroundings.markers.detail", result)
        }
      })

      if (!this.isMobile) {
        const popupDetails = polygonOriginalMarker ? polygonOriginalMarker : marker
        marker.on("mouseover", (e) => {
          const popup = this.openPopup(e, popupDetails)
          if (polygonOriginalMarker) {
            marker.on("mousemove", (mmevent) => {
              popup.setLatLng([mmevent.latlng.lat, mmevent.latlng.lng])
            })
          }
        })

        marker.on("mouseout", () => {
          this.map.closePopup()
          marker.off("mousemove")
        })
      }

      marker.on("manualpopuptrigger", (e) => {
        // not currently working
        L.popup().setLatLng([e.target._latlng.lat, e.target._latlng.lng]).setContent("<div></div>").openOn(this.map)

        // then shut it immediately
        this.map.closePopup()
      })
    } else if (!polygonOriginalMarker) {
      this.handleManageMarkerClick(marker)
    }
  }

  handleManageMarkerClick(marker) {
    marker.on("click", (e) => {
      // for some reason click event firing after drag
      // causing dialog to open
      if (this.dragged) {
        this.dragged = false
        return
      }
      this.editMarker(e)
    })
  }

  manageLogout() {
    this.$window.location.href = "/logout"
  }

  createNewMarkerFromManage() {
    this.manageFeedback = "Click map to set the marker position"
    this.addMarkerButtonReady = false
    this.map.on("click", (evt) => {
      this.addMarkerButtonReady = true
      this.showNewMarkerForm(evt)
      this.resetManageFeedback()
      this.map.off("click")
    })
  }

  editMarker(marker) {
    this.showNewMarkerForm(marker, true)
  }

  getPolygonLayer(itemData, markerForPolygon) {
    const newPolygonShape = itemData.polygonshape.map((point) => [point[1], point[0]])
    const polygonOptions = this.isManagePage
      ? { color: "red" }
      : { fillOpacity: 0, stroke: false, bubblingMouseEvents: false }
    let polygonMarker = L.polygon(newPolygonShape, polygonOptions)
    this.addMapItemListeners(polygonMarker, markerForPolygon)
    return polygonMarker
  }

  addPolygonToMarker(item, marker) {
    if (item.polygonshape && item.polygonshape.length) {
      const polygon = this.getPolygonLayer(item, marker)
      this.addLayerToAllMarkers(polygon)
    }
  }

  addMarkerLayers(type, data) {
    for (let j = 0; j < data.length; j++) {
      const item = data[j]
      const marker = this.createMarker(item, type)
      this.addPolygonToMarker(item, marker)
      this.addLayerToAllMarkers(marker)
    }
  }

  setMapBounds() {
    mapBounds = this.map.getBounds()
  }

  // not sure if this is even required anymore??
  showAllAllVisibleMarkers() {
    // if (this.map.getZoom() < 0) {
    //   for (let j = 0; j < allMarkerLayersLength; j++) {
    //     this.map.removeLayer(allMarkerLayers[j]);
    //   }
    // } else {
    this.setMapBounds()
    // todo not sure if listeners should be removed and added for each marker added to map or not - research, there is a an event for each marker add to map

    for (let i = 0; i < allMarkerLayersLength; i++) {
      //if (mapBounds.contains(allMarkerLayers[i].getLatLng())) {
      // let marker = allMarkerLayers[i];
      // on mobile mouse over seems to be firing on tap, and is very fast so using that.

      this.map.addLayer(allMarkerLayers[i])
      //} else {
      //  this.map.removeLayer(allMarkerLayers[i]);
      //}
    }
    //}
  }

  findMarkerByName(name) {
    return this.layerGroups.allMarkers.getLayers().find((markerLayer) => markerLayer.options.urlstringid === name)
  }

  getMarker() {
    return this.findMarkerByName(this.transitionParams.name)
  }

  setShouldPick() {
    if (this.transitionParams.shouldpick && this.transitionParams.shouldpick === "pick") {
      console.log("should pick set true")
      this.shouldPick = true
    }
  }

  checkIsAvailabilityRoute = () =>
    this.$state.current.name === "mainmap.home.availability" ||
    this.$state.current.name === "mainmap.home.availability-with-occupancy"

  setupTransitions() {
    if (this.$state.current.name === "mainmap.home.availability-check-showing") {
      this.setAvailabilityCheckShowing(true)
    }
    if (this.checkIsAvailabilityRoute()) {
      this.availabilityTransition = true
      this.setAvailabilityCheckShowing(true)
      this.setShouldPick()
      this.checkAndSetAvailabilityNotMinimized()
    } else if (this.transitionParams.name) {
      this.checkAndSetAvailabilityMinimized()
      this.detailShowing = true
      let marker = this.getMarker()
      this.markerType = this.transitionParams.marker
      this.checkShouldTransitionIntoView(marker)
      this.setCorrectHighlight(marker)
      this.setMapBounds()
    }

    this.deregisterTransitionListener = this.$transitions.onSuccess({}, (transition) => {
      this.transitionParams = transition.params()
      if (this.$state.current.name === "mainmap.home.availability-status") {
        this.checkAndSetAvailabilityNotMinimized()
        this.setAvailabilityStatusShowing(true)
        this.setAvailabilityCheckShowing(false)
        this.detailShowing = false
      } else if (this.checkIsAvailabilityRoute()) {
        this.availabilityTransition = true
        this.setShouldPick()
      } else if (this.transitionParams.name) {
        this.checkAndSetAvailabilityMinimized()
        this.detailShowing = true
        let marker = this.getMarker()
        if (!isMarkerClick) {
          this.markerType = this.transitionParams.marker
          this.checkShouldTransitionIntoView(marker)
          this.activateMarker(marker)
        }
        isMarkerClick = false
      } else {
        this.detailShowing = false
        this.availabilityStatusShowing
          ? this.checkAndSetAvailabilityNotMinimized()
          : this.checkAndSetAvailabilityMinimized()
      }
    })
  }

  checkShouldTransitionIntoView(marker) {
    // this currently not working, firstly mapbounds not set yet, need to reorder line 648.
    // Second opening the popup doesn't make map scroll to it?
    if (mapBounds) {
      if (!mapBounds.contains(marker.getLatLng())) {
        marker.fire("manualpopuptrigger")
      }
    }
  }

  $onDestroy() {
    this.map.off("moveend")
    this.mapWindowResize()
    if (this.deregisterTransitionListener) {
      this.deregisterTransitionListener()
    }
    if (this.deregisterTransitionListener2) {
      this.deregisterTransitionListener2()
    }
  }

  setAllMarkersLengthForOptim() {
    allMarkerLayers = this.layerGroups.allMarkers.getLayers()
    allMarkerLayersLength = allMarkerLayers.length
  }

  resetManageFeedback() {
    this.manageFeedback = null
    this.addMarkerButtonReady = true
  }

  checkAndSetAvailabilityMinimized(fromClick) {
    if (this.campsitedata.showavailability && !this.$window.flippers.isAvailabilityHidden) {
      if (!this.availabilityStatusMinimized) {
        this.availabilityStatusMinimized = true
        if (fromClick && !this.$scope.$$phase) {
          this.$scope.$apply()
        }
      }
    }
  }

  checkAndSetAvailabilityNotMinimized() {
    if (this.campsitedata.showavailability && !this.$window.flippers.isAvailabilityHidden) {
      if (this.availabilityStatusMinimized) {
        this.availabilityStatusMinimized = false
      }
    }
  }

  setDynamicFonts() {
    // In future this font could be set in data for campsite
    if (this.campsitedata.name === "polmanter") {
      document.body.setAttribute("style", "font-family:BrandonText;")
    }
  }

  initMap() {
    // Wait for DOM element to be available before initializing map
    this.waitForMapContainer(() => {
      this.setDynamicFonts()
      this.campsiteMarkers = [...this.campsitedata.facilities, ...this.campsitedata.markers]
      this.setMainMapSize()
      this.loadMap()
      this.addEventListeners()
      this.addMarkers()

      this.setAllMarkersLengthForOptim()
    })
  }

  waitForMapContainer(callback) {
    const checkForElement = () => {
      const mapContainer = document.getElementById("map-aerial")
      if (mapContainer) {
        callback()
        // Continue with the rest of the initialization after map is ready
        this.setupTransitions()
        this.addTransitions()
        this.showAllAllVisibleMarkers("allMarkers")
        this.setupMapEventListeners()
      } else {
        // Use requestAnimationFrame for better performance than setTimeout
        requestAnimationFrame(checkForElement)
      }
    }
    checkForElement()
  }

  setupMapEventListeners() {
    // this seems to be required still, as availability layers gets removed on clear
    if (this.map) {
      this.map.on("moveend", () => {
        this.showAllAllVisibleMarkers("allMarkers")
      })
      this.map.on("click", () => {
        if (this.$state.current.name === "mainmap.markers.detail") {
          this.isMapClick = true
          this.$state.go("mainmap.home")
        }
      })
    }
  }

  $onInit() {
    this.transitionParams = this.$transition$.params()
    this.appReady = false
    this.isMobile = this.$window.innerWidth < 1024

    this.requiredRequestsLoaded = this.campsitedata.showOccupancyChoices ? false : true

    // temporary for mountain falls demo, should be moved onto real manage area really
    if (this.campsitedata.name === "mountain-falls") {
      this.campsitedata.showHighlights = true
      this.campsitedata.markers = this.campsitedata.markers.map((marker) => {
        if (marker.name === "1" || marker.name === "2") {
          marker.highlightType = "rentals"
        } else {
          marker.highlightType = "sales"
        }
        return marker
      })
    }

    if (!this.$window.flippers) {
      const urlSearchParams = new URLSearchParams(this.$window.location.search)
      this.$window.flippers = {
        isSurroundingsShowing:
          (this.campsitedata.name === "polmanter" && urlSearchParams.has("show-surroundings", true)) ||
          this.campsitedata.name !== "polmanter",
        isAvailabilityHidden:
          (this.campsitedata.name === "polmanter" && urlSearchParams.has("hide-availability", true)) || false,
        isToolbarShowing:
          (this.campsitedata.name === "polmanter" && !this.isMobile && urlSearchParams.has("show-toolbar", true)) ||
          false,
      }
    }

    if (this.$state.current.name === "surroundings") {
      let result = { markers: "surroundings", name: this.campsitedata.placesofinterest[0].urlstringid }
      this.$state.go("surroundings.markers.detail", result)
    }

    this.Auth.getCurrentUser().then((response) => {
      this.userRole = response.role
      if (response.role === "admin") {
        this.isAdmin = true
      }
      if (response.role === "admin" || response.role === "manager") {
        this.$state.go(`${this.$state.current.name}.manage`)
        this.isManaging = true
        this.manageFeedback = null
        this.addMarkerButtonReady = true
        this.isManagePage =
          this.$state.current.name === "mainmap.manage" || this.$state.current.name === "surroundings.manage"
      } else {
        this.$state.go(`${this.$state.current.name}.home`)
      }
      this.initMap()
    })
  }
}
